import CryptoJS from "crypto-js";
const secret_key = process.env.REACT_APP_SECRET_KEY;
const iv = process.env.REACT_APP_SECRET_IV;
function decrypt(encryptedData) {
  if(!encryptedData){
    return console.error('Encrypted Data Not Found!!')
  }
  var bytes = CryptoJS.AES.decrypt(
    encryptedData,
    CryptoJS.enc.Utf8.parse(secret_key),
    { iv: CryptoJS.enc.Utf8.parse(iv) }
  );
  var originalText = bytes.toString(CryptoJS.enc.Utf8);
  try {
    return JSON.parse(originalText);
  } catch (e) {
    return originalText;
  }
}
export default decrypt;
